<section nz-row class="search-list">
  <!-- 表单部分 -->
  <form nz-form class="company-form">
    <section *ngIf="showInput">
      <section class="search">
        <nz-input-group [nzPrefix]="prefixTemplateUser">
          <input type="text" nz-input [placeholder]="placeholder" (keyup.enter)="onEnter()" [(ngModel)]="value" (ngModelChange)="searchChange($event)" [ngModelOptions]="{standalone: true}" />
        </nz-input-group>
        <ng-template #prefixTemplateUser><img width="20px" height="20px" [src]="'http://ks3-cn-beijing.ksyuncs.com/jns.img.bucket//27a02b43-96bd-408e-8312-6300de829e45.png'" loading="lazy" /></ng-template>
        <button type="button" nz-button class="default" (click)="onReset()">{{ i18nDictionary.reset || '重置' | translate }}</button>
        <button type="button" nz-button (click)="onEnter()">{{ i18nDictionary.search || '搜索' | translate }}</button>
      </section>
    </section>

    <ng-container *ngFor="let item of controlsPanel;">
      <ng-container *ngIf="[eSearchType.TAG, eSearchType.TAG_RANGE].includes(item.type)">
        <!-- <ng-template *ngTemplateOutlet="tagItem;context:{data: item}"></ng-template> -->
        <section class="rows">
          <section  nz-row nzJustify="start">
            <section nz-col nzSpan="24">
              <nz-form-item class="form-item" nz-row>
                <nz-form-label nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="2" nzXXl="2" class="label">{{item.label | translate}}</nz-form-label>
                <nz-form-control nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="22" nzXXl="23" class="tagl">
                  <section *ngFor="let itm of item.list" nzMode="checkable" [ngClass]="{active: itm.flag}" class="tag-item value"
                    (click)="checkChange(item.type, itm, item.list, itm.value, item.name,item.children,item.thirdChildren)">{{itm.labelLang? (itm.labelLang | translate) : itm.label}}</section>
                  <span class="font-size-14" style="color: #227BEE;cursor: pointer;" *ngIf="item.data && item.minLength && item.data.length > item.minLength" (click)="viewMore(item)">{{ (item.collapse ? (i18nDictionary.retract || '收起') : (i18nDictionary.expansion || '查看全部')) | translate }}</span>
                </nz-form-control>
              </nz-form-item>
            </section>
          </section>
        </section>
        <ng-container *ngIf="item.children && item.children.data && item.children.data.length && item.children.list.length">
          <section class="rows">
            <section  nz-row nzJustify="start">
              <section nz-col nzSpan="24">
                <nz-form-item class="form-item" nz-row>
                  <nz-form-label nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="2" nzXXl="2" class="label">{{item.children.label | translate}}</nz-form-label>
                  <nz-form-control nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="22" nzXXl="23" class="tagl">
                    <section *ngFor="let itm of item.children.list" nzMode="checkable" [ngClass]="{active: itm.flag}" class="tag-item value"
                      (click)="checkChange(item.type, itm, item.children.list, itm.value, item.children.name, item.thirdChildren)">{{itm.labelLang? (itm.labelLang | translate) : itm.label}}</section>
                    <span class="font-size-14" style="color: #227BEE;cursor: pointer;" *ngIf="item.children.data && item.children.minLength && item.children.data.length > item.children.minLength" (click)="viewMore(item.children)">{{ (item.children.collapse ? (i18nDictionary.retract || '收起') : (i18nDictionary.expansion || '查看全部')) | translate }}</span>
                  </nz-form-control>
                </nz-form-item>
              </section>
            </section>
          </section>
        </ng-container>
        <ng-container *ngIf="item.thirdChildren && item.thirdChildren.data && item.thirdChildren.data.length && item.thirdChildren.list.length">
          <section class="rows">
            <section  nz-row nzJustify="start">
              <section nz-col nzSpan="24">
                <nz-form-item class="form-item" nz-row>
                  <nz-form-label nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="2" nzXXl="2" class="label">{{item.thirdChildren.label | translate}}</nz-form-label>
                  <nz-form-control nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="22" nzXXl="23" class="tagl">
                    <section *ngFor="let itm of item.thirdChildren.list" nzMode="checkable" [ngClass]="{active: itm.flag}" class="tag-item value"
                      (click)="checkChange(item.type, itm, item.thirdChildren.list, itm.value, item.thirdChildren.name)">{{itm.labelLang? (itm.labelLang | translate) : itm.label}}</section>
                    <span class="font-size-14" style="color: #227BEE;cursor: pointer;" *ngIf="item.thirdChildren.data && item.thirdChildren.minLength && item.thirdChildren.data.length > item.thirdChildren.minLength" (click)="viewMore(item.thirdChildren)">{{ (item.thirdChildren.collapse ? (i18nDictionary.retract || '收起') : (i18nDictionary.expansion || '查看全部')) | translate }}</span>
                  </nz-form-control>
                </nz-form-item>
              </section>
            </section>
          </section>
        </ng-container>
      </ng-container>
    </ng-container>
  </form>
</section>
